module.exports = {"forgotpassword":"Esqueceu sua senha?"}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/LoginForm/data.json
// module id = 2113
// module chunks = 0